"use strict";
'use client';
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMutation = void 0;
var axios_1 = __importDefault(require("axios"));
var react_1 = require("react");
var swr_1 = require("swr");
var mutation_1 = __importDefault(require("swr/mutation"));
var mutationWrapepr_1 = require("./mutationWrapepr");
var updateCSRFToken = function (token) {
    var csrfMeta = document.querySelector("meta[name=\"".concat(CSRF_TOKEN, "\"]"));
    if (csrfMeta && token)
        csrfMeta.setAttribute('content', token);
};
var CSRF_TOKEN = 'x-csrf-token';
var makeRequest = function (url, _a) {
    var _b = _a.arg, arg = _b === void 0 ? {} : _b;
    return __awaiter(void 0, void 0, void 0, function () {
        var isFormData, csrfMeta, _c, headers, data, response, err_1;
        var _d;
        var _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    isFormData = arg instanceof FormData;
                    if (isFormData)
                        return [2 /*return*/, axios_1.default.post(url, arg)];
                    csrfMeta = document.querySelector("meta[name=\"".concat(CSRF_TOKEN, "\"]"));
                    _c = arg.headers, headers = _c === void 0 ? {} : _c, data = __rest(arg, ["headers"]);
                    _f.label = 1;
                case 1:
                    _f.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, axios_1.default.post(url, data, {
                            headers: __assign(__assign({}, headers), (_d = {}, _d[CSRF_TOKEN] = (csrfMeta === null || csrfMeta === void 0 ? void 0 : csrfMeta.content) || '', _d)),
                        })];
                case 2:
                    response = _f.sent();
                    updateCSRFToken(response === null || response === void 0 ? void 0 : response.headers[CSRF_TOKEN]);
                    return [2 /*return*/, response];
                case 3:
                    err_1 = _f.sent();
                    updateCSRFToken((_e = err_1 === null || err_1 === void 0 ? void 0 : err_1.response) === null || _e === void 0 ? void 0 : _e.headers[CSRF_TOKEN]);
                    throw err_1;
                case 4: return [2 /*return*/];
            }
        });
    });
};
var useMutation = function (_a) {
    var _b;
    var _c = _a === void 0 ? {} : _a, successAction = _c.successAction, errorAction = _c.errorAction, keysUpdate = _c.keysUpdate, clearKeys = _c.clearKeys, path = _c.path, _d = _c.canRender, canRender = _d === void 0 ? true : _d;
    var mutate = (0, swr_1.useSWRConfig)().mutate;
    var _e = (0, mutation_1.default)(canRender ? path : null, makeRequest, {
        onSuccess: function (res) {
            successAction === null || successAction === void 0 ? void 0 : successAction(res);
            if (keysUpdate && keysUpdate.length > 0)
                keysUpdate.forEach(function (key) {
                    mutate(key);
                });
            if (clearKeys && clearKeys.length > 0)
                clearKeys.forEach(function (key) {
                    mutate(key, null);
                });
        },
        onError: function (err) {
            errorAction === null || errorAction === void 0 ? void 0 : errorAction(err);
        },
    }), trigger = _e.trigger, isMutating = _e.isMutating, error = _e.error, data = _e.data;
    return (0, react_1.useMemo)(function () {
        var _a;
        return ({
            mutate: (0, mutationWrapepr_1.mutationWrapper)(trigger),
            isSubmitting: isMutating,
            error: (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data,
            data: data,
        });
    }, [(_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.data, isMutating, trigger, data]);
};
exports.useMutation = useMutation;
